import type { EventBusKey } from '@vueuse/core'

export const stringStylesToObject = (styles: string) => {
  const lines = styles
    .split(';')
    .map(line => line.trim())
    .filter(Boolean)

  const entries = lines.map(line => line.split(':'))

  return entries.reduce((styles, [key, value]) => {
    return {
      ...styles,
      [key]: value,
    }
  }, {})
}

export const inRange = (from: number, to: number, value: number) => {
  return value < from ? from : value > to ? to : value
}

const floatRegexp = '[-+]?[0-9]*.?[0-9]+'

const types = [
  {
    name: 'px',
    regexp: new RegExp(`^${floatRegexp}px$`),
  },
  {
    name: '%',
    regexp: new RegExp(`^${floatRegexp}%$`),
  },
  /**
   * Fallback option
   * If no suffix specified, assigning "px"
   */
  {
    name: 'px',
    regexp: new RegExp(`^${floatRegexp}$`),
  },
]

const getType = (value: string) => {
  if (value === 'auto') {
    return {
      type: value,
      value: 0,
    }
  }

  const type = types.find(type => type.regexp.test(value))

  if (type) {
    return {
      type: type.name,
      value: parseFloat(value),
    }
  }

  return {
    type: '',
    value,
  }
}

export const parseSizeNumber = (value) => {
  switch (typeof value) {
    case 'number':
      return { type: 'px', value }
    case 'string':
      return getType(value)
    default:
      return { type: '', value }
  }
}

export const validateNumber = (value: number | string) => {
  if (typeof value === 'string') {
    const num = parseSizeNumber(value)

    return (num.type === '%' || num.type === 'px') && num.value > 0
  }

  return value >= 0
}

export const modalsInjectionKey: EventBusKey<string> = Symbol('modals-key')

// Different browsers handle innerWidth/clientWidth differently,
// this function tries to return the smallest width (assuming that it excludes
// scrollbar width)
export const windowWidthWithoutScrollbar = () => {
  const { innerWidth } = window
  const { clientWidth } = document.documentElement

  if (innerWidth && clientWidth) {
    return Math.min(innerWidth, clientWidth)
  }

  return clientWidth || innerWidth
}
